import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/dist/scss/components/heading.scss.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import '@flixbus/honeycomb-icons-react';
import '../../packages/props-utils/prop-types.js';
import { HEADING_ELEMS } from './types.js';
import { Injecss } from '../../packages/injecss/injecss.js';

function Heading(_a) {
  var {
      children,
      extraClasses,
      flushSpace = false,
      sectionHeader = false,
      size,
      Elem
    } = _a,
    rest = __rest(_a, ["children", "extraClasses", "flushSpace", "sectionHeader", "size", "Elem"]);
  // different heading type requires different HTML tags
  const Element = Elem || "h".concat(size);
  // different Heading size has different block class name, e.g. `flix-h1`, `flix-h4`
  const headingBem = new HoneyBem("h".concat(size), styles);
  const headingClassNames = headingBem.b({
    'section-header': sectionHeader,
    'space-flush': flushSpace
  }, extraClasses);
  return /*#__PURE__*/React.createElement(Element, Object.assign({
    className: headingClassNames
  }, rest), children);
}
Heading.displayName = 'Heading';
Heading.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.array]).isRequired,
  flushSpace: PropTypes.bool,
  extraClasses: PropTypes.string,
  sectionHeader: PropTypes.bool,
  size: PropTypes.oneOf([1, 2, 3, 4]).isRequired,
  Elem: PropTypes.oneOf(HEADING_ELEMS)
};
var Heading$1 = Injecss(Heading, styles);

export { Heading, Heading$1 as default };
